import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SubNavigationItems, { SubNavigationItemProps } from "go-app/components/Navigation/SubNavigationItems";
import { hasRole, selectIsAdmin } from "../../../../../services/users/selectors";

const SupportNavigation = () => {
	const { t } = useTranslation("admin");
	const isAdmin = useSelector(selectIsAdmin);
	const hasSupportRole = useSelector(hasRole("SUPPORT"));

	const items: SubNavigationItemProps[] = [
		{
			title: t("modules.support.field.organizations.title"),
			route: "/support/organizations_with_access",
		},
		{
			title: t("modules.support.field.search_organization.title"),
			route: "/support/search_organization",
		},
		{
			title: t("modules.support.field.support_actions.title"),
			route: "/support/actions",
			hide: !(isAdmin || hasSupportRole),
		},
	];

	return <SubNavigationItems title={t("modules.support.header.title")} items={items} />;
};

export default SupportNavigation;
